'use client';

import { c as _c } from "react/compiler-runtime";
import { useAppBack } from '@/modules/wello-app/_hooks/useAppBack';
export const AppBack = () => {
  const $ = _c(1);
  useAppBack();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};